import { webApi } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { FragmentCardMediaOverlay } from '../base/FragmentCardMediaOverlay';
import { PosterVariant } from '../hooks/useFragmentPosterPolling';
import { FragmentCardPosterWithPolling } from './FragmentCardPosterWithPolling';
import { VideoFragmentVariantChip } from './VideoFragmentVariantChip';

/**
 * Media area for video fragment: poster image with overlay (time, statuses, duration)
 * and optional dev-only variant chip.
 * Wrapped in a 16:9 aspect-ratio box so the media never stretches in compact/small grids.
 */
export function VideoFragmentMedia({
  fragment,
  posterSrc,
  variant,
}: {
  fragment: webApi.FragmentListItemDto;
  posterSrc: string | null;
  variant: PosterVariant | null;
}) {
  return (
    <Box
      sx={{
        width: '100%',
        aspectRatio: '16/9',
        overflow: 'hidden',
      }}
    >
      <FragmentCardMediaOverlay fragment={fragment} sx={{ width: '100%', height: '100%' }}>
        <FragmentCardPosterWithPolling
          fragmentId={fragment.id}
          posterSrc={posterSrc}
          variant={variant}
        />
        <VideoFragmentVariantChip variant={variant} />
      </FragmentCardMediaOverlay>
    </Box>
  );
}
